export default "__VITE_ASSET__DJQxGMW6__"